import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoleType } from '@enums/role-type.enums';
import { DomainRole } from '@services/genesys-cloud-user.interface';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-community-list',
  templateUrl: './community-list.component.html',
  styleUrls: ['./community-list.component.scss'],
  imports: [NgTemplateOutlet],
})
export class CommunityListComponent {
  @Input() role: DomainRole;
  @Output() readonly linkClick = new EventEmitter<boolean>();

  /**
   * Domain Role Type Enum
   * @returns {typeof RoleType}
   */
  public get roleType(): typeof RoleType {
    return RoleType;
  }

  /**
   * Emit link click event to parent
   */
  onLinkClick(): void {
    console.log('Community Link clicked');
    this.linkClick.emit(true);
  }
}
